var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", {
    attrs: { href: "#", title: _vm.atitle },
    domProps: { innerHTML: _vm._s(_vm.linkText) },
    on: {
      click: function($event) {
        $event.preventDefault()
        return _vm.openDialog($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }